import ReactGA from 'react-ga';

const Dimensions = {
    VERSION: 'dimension1'
};

const ENABLED = process.env.REACT_APP_DISABLE_GA !== 'true'

/**
 * See .env.development for the REACT_APP_GA_TRACKING_ID variable definition
 * */
export const initialize = () => {
    if (ENABLED) {
        const trackingId = process.env.REACT_APP_GA_TRACKING_ID;
        if (!trackingId) {
            throw Error('REACT_APP_GA_TRACKING_ID is not set. Check the build configuration');
        }
        ReactGA.initialize(trackingId, {
            debug: process.env.NODE_ENV === 'development',
        });
        window.addEventListener('error', function(event) {
            window.removeEventListener('error', this);
            exception(`${event.message}:${event.filename}:${event.lineno}`, true);
        });
        ReactGA.set({
            [Dimensions.VERSION]: process.env.REACT_APP_VERSION
        });
    } else {
        console.warn('GA DISABLED');
        return;
    }
};

export const setUserId = userId => {
    ENABLED && ReactGA.set({ userId });
};

export const pageView = () => {
    ENABLED && ReactGA.pageview(window.location.pathname + window.location.search);
};

export const modalView = modalName => {
    ENABLED && ReactGA.modalview(modalName);
};

export const EventCategory = {
    User: 'User',
    TripSharing: 'TripSharing',
    DashboardMap: 'DashboardMap',
    Updates: 'Updates',
};

export const EventAction = {
    SignIn: 'SignIn',
    SignOut: 'SignOut',
    Connect: 'Connect',
    ToggleLayerVisibility: 'ToggleLayerVisibility',
    UpdateFound: 'UpdateFound',
    AutoReload: 'AutoReload',
};

export const event = args => {
    // https://github.com/react-ga/react-ga#reactgaeventargs
    // { category, action, label, value, nonInteraction } = args;
    if (!EventCategory[args.category]) console.warn(`sendEvent: invalid category specified: ${args.category}`)
    if (!EventAction[args.action]) console.warn(`sendEvent: invalid action specified: ${args.action}`)
    ENABLED && ReactGA.event(args);
};

const callSiteString = () => new Error().stack.split(/\n/, 2).join(':');

export const exception = (err, fatal) => {
    const description = !err ? callSiteString() : (
        (typeof err === 'string') ? err : (
            err.message ? err.message : JSON.stringify(err).substring(0,255)
        )
    );
    ENABLED && ReactGA.exception({ description, fatal });
};
